const NavigationTokens = {
  RegZipCode: "RegZipCode",
  Logout: "Logout",
  ManageAddresses: "ManageAddresses",
  ChangeCartAddress: "ChangeCartAddress",
  ShoppingCart: "ShoppingCart",
  SinglePageCheckout: "SinglePageCheckout",
  ShippingAddress: "ShippingAddress",
  selectAccount: "SelectAccount",
  wbGsa: "WBGSA",
  accountStatement: "AccountStatement",
  invoiceHistory: "InvoiceHistory",
  reports: "Reports",
  manageUsers: "ManageUsers",
  manageGroups: "ManageGroups",
  manageAddresses: "ManageAddresses",
  manageExpenseAllocations: "ManageExpenseAllocations",
  manageCreditCards: "ManageCreditCards",
  manageCheckingAccounts: "ManageCheckingAccounts",
  budgets: "Budgets",
  workflow: "Workflow",
  orderHistory: "OrderHistory",
  dashboard: "Dashboard",
  myWbRecentItems: "MyWBRecentItems",
  customerService: "CustomerService",
  faqs: "FAQs",
  regUserRegistration: "RegUserRegistration",
  quickOrder: "QuickOrder",
  returnCenter: "ReturnCenter",
  myLists: "MyLists",
  home: "Home",
  myAccount: "MyAccount",
  myListDetails: "MyListDetails",
  OrdersAwaitingApproval: "OrdersAwaitingApproval",
  OrderAwaitingApprovalDetails: "OrderAwaitingApprovalDetails",
  OrderHistoryDetails: "OrderHistoryDetails",
  ManageRecurringPayments: "ManageRecurringPayments",
  savedCarts: "SavedCarts",
  contactUs: "ContactUs",
  Punchout: "Punchout",
  OISignup: "OISignup",
  Login: "Login",
  SelectAccount: "SelectAccount"
};

export default NavigationTokens;
